export function isValidCNPJ(cnpj: string): boolean {
  if (!cnpj) {
    return false;
  }

  const normalizedCnpj = cnpj
    .toUpperCase()
    .replace(/[\/\s.-]+/gim, '');

  if (!/^[A-Z0-9]{14}$/.test(normalizedCnpj)) {
    return false;
  }

  let generatedCnpj = normalizedCnpj.slice(0, 12);
  const cnpjArray = normalizedCnpj
    .split('')
    .map((char) => char.charCodeAt(0) - 48);

  const products = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  while (generatedCnpj.length < 14) {
    let sum = 0;

    for (let i = 0; i < cnpjArray.length && i < products.length; i += 1) {
      sum += cnpjArray[i] * products[i];
    }

    const digitAscii = (11 - (sum % 11)) + 48;

    generatedCnpj += String.fromCharCode(digitAscii);
    cnpjArray.push(digitAscii);
    products.unshift(6);
  }

  return generatedCnpj === normalizedCnpj;
}
